<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" :label-width="80" inline>
          <FormItem label="类型">
            <Input v-model="form.typeName"></Input>
          </FormItem>
          <FormItem label="类型枚举">
            <Input v-model="form.flowType"></Input>
          </FormItem>
        </Form>
        <div class="toolbar">
          <Button type="primary" icon="md-add" @click="handleCreate">新增</Button>
          <Button type="primary" icon="md-trash" @click="handleDelete">删除</Button>
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
              @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
    </Card>
    <flowtypeInfo ref="flowtypeInfoRef" @handle-search="handleSearch"></flowtypeInfo>
  </div>
</template>

<script>
import flowtypeInfo from './flowtype-info'
import { getIds } from '@/libs/util'

export default {
  name: 'flowtype-list',
  components: {
    flowtypeInfo
  },
  data () {
    return {
      columns: [
        { title: '类型', key: 'typeName' },
        { title: '类型枚举', key: 'flowType' },
        { title: '创建人', key: 'crtUserId' },
        { title: '创建时间', key: 'crtTime' },
        {
          title: '操作',
          key: 'handle',
          minWidth: 200,
          options: ['update', 'detail']
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleUpdate (param) {
      this.$refs.flowtypeInfoRef.openModel('update', param.row)
    },
    handleDetail (param) {
      this.$refs.flowtypeInfoRef.openModel('detail', param.row)
    },
    handleCreate () {
      this.$refs.flowtypeInfoRef.openModel('create')
    },
    handleDelete () {
      this.D('flowtype', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      let param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.L('flowtype', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
